module.exports = __webpack_public_path__ + "img/city-template-cta-desktop.30d184e2.webp";